import $ from 'jquery';
import IMask from 'imask';

function showLoading() {
  $('#minas-sign-up-btn').hide();
  $('#minas-sign-up-btn-loading').show();
}

function hideLoading() {
  $('#minas-sign-up-btn').show();
  $('#minas-sign-up-btn-loading').hide();
}


export function validateCPF(cpf) {
  if (cpf.replaceAll(/\D/g, '').length !== 11) return false

  if (/^([0-9])\1{10}$/.test(cpf)) return false

  const getNextVerificationDigit = (stringSlice) => {
    let sum = 0
    for (let i = 0; i < stringSlice.length; i++) {
      const digit = +stringSlice[i]
      const constant = stringSlice.length + 1 - i
      sum += digit * constant
    }
    const remainder = sum % 11
    return (remainder < 2 ? 0 : 11 - remainder) + ''
  }

  const firstValidDigit = getNextVerificationDigit(cpf.slice(0, 9))
  const secondValidDigit = getNextVerificationDigit(
    cpf.slice(0, 9) + firstValidDigit,
  )

  return cpf === cpf.slice(0, 9) + firstValidDigit + secondValidDigit
}


$(document).ready(function () {
  let currentPage = 'login';
  const loginPage = $('#minas-login');
  const signUpPage = $('#minas-signup');
  const minasGoBackButton = $('#minas-goback-button');

  IMask(document.getElementById("cpf"), {
    mask: [
      {
        mask: '000.000.000-00',
        overwrite: true,
        placeholderChar: '_',
        lazy: false,
      }]
  });

  $('#registerButton').click(() => {
    currentPage = 'signup';
    loginPage.hide();
    signUpPage.show();
    minasGoBackButton.show();
  });

  $('#minas-goback-button').click(() => {
    if (currentPage === 'login') {
      loginPage.hide();
      signUpPage.show();
      currentPage = 'signup';
    } else {
      signUpPage.hide();
      loginPage.show();
      minasGoBackButton.hide();
      currentPage = 'login';
    }
  });

  $('#minas-signup-form').on('submit', function (event) {
    event.preventDefault();

    //transforms form data into json
    const formData = $(this).serializeArray();
    const jsonData = {};
    formData.forEach(item => {
      jsonData[item.name] = item.value.replaceAll(/\D/g, '');
    });

    if (!jsonData.cpf || !validateCPF(jsonData.cpf) || !jsonData.rnp) {
      $('#sign-up-error').show();
      $('#sign-up-error-user').hide();
      return;
    }

    const updatedFormData = formData.map(item => {
      if (item.name === "cpf") {
        return { ...item, value: item.value.replace(/\D/g, '') };
      }
      return item;
    });

    const form = $(this);
    const method = form.attr('method');

    // Navigates to registration route: https://bancodetalentos.org/c/registro/cadastra?token=457uiohodsfgioasfd4453
    // send to this endpoint

   showLoading();
   $('#sign-up-error').hide();
   $('#sign-up-error-user').hide();

    $.ajax({
      url: '/api/v3/crea_mg/auth',
      type: method,
      data: updatedFormData,
      success: function (response) {
        hideLoading();

        if (response.error == 'situação inválida') {
          $('#sign-up-error').show();
          return;
        }

        if (response.error == 'usuário já existe') {
          $('#sign-up-error-user').show();
          return;
        }
        window.location.href = `https://bancodetalentos.org/c/registro/cadastra?token=${response.token}`;
      },
      error: function (xhr, status, error) {
        console.error('Form submission failed:', error);
        hideLoading();
        $('#sign-up-error').show();
      },

    });
  }
  );
});
